import { render, staticRenderFns } from "./ModelPaidVideoCard.vue?vue&type=template&id=51c335ed&scoped=true&"
import script from "./ModelPaidVideoCard.vue?vue&type=script&lang=js&"
export * from "./ModelPaidVideoCard.vue?vue&type=script&lang=js&"
import style0 from "./ModelPaidVideoCard.vue?vue&type=style&index=0&id=51c335ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c335ed",
  null
  
)

export default component.exports